import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';

const ChatSideBar = (props) => {
  return (
    <>
      <Sidebar visible={props.visible} onHide={() => props.setVisible(false)}>
        {props.children}
      </Sidebar>
    </>
  );
};
  
export default ChatSideBar;


